<ng-container>
    <div class="header">
        <div class="filters-container">
            <app-user-is-external-dropdown (selectionChange)="onUserTypeChange($event)" [value]="selectedUserType"></app-user-is-external-dropdown>
            <app-spacer></app-spacer>
            <app-spacer></app-spacer>
            <app-search-input (keyupp)="onSearchChange($event)"></app-search-input>
        </div>
    </div>
    <div class="container">
        <app-exper-table [tableId]="'users-management-table'" [dataSource]="dataSource" [initialSortActive]="initialSortActive"
            [initialSortDirection]="initialSortDirection" (matSortChange)="storeSortOptions($event)"
            (pageChanged)="storePageOptions($event)"
            [initialPage]="initialPage" [initialPageSize]="initialPageSize">
            <ng-container matSort>
                <app-exper-column name="firstName" labelT="admin.user-management.first-name">
                    <ng-template let-row>
                        {{ row.firstName }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="lastName" labelT="admin.user-management.last-name">
                    <ng-template let-row>
                        {{ row.lastName }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="account" labelT="admin.user-management.account">
                    <ng-template let-row>
                        {{ getAccountType(row.isInternal) }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="organization" labelT="admin.user-management.organization-unit">
                    <ng-template let-row>
                        {{ row.organizationUnit }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="email" labelT="admin.user-management.email">
                    <ng-template let-row>
                        {{ row.mail }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="createdDate" labelT="admin.user-management.created-date">
                    <ng-template let-row>
                        {{ row.accountCreatedDate | date: 'dd.MM.yyyy HH:mm:ss' }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="lastLogin" labelT="admin.user-management.last-activity">
                    <ng-template let-row>
                        {{ row.lastSuccessfulLoginDate | date: 'dd.MM.yyyy HH:mm:ss' }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="isActive" labelT="admin.user-management.is-active">
                    <ng-template let-row>
                        {{ getIsActiveValueTranslationKey(row.isActive) | translate }}
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="actions" label="" [noSort]="true">
                    <ng-template let-row>
                        <app-button-edit (click)="navigateToUserProfile(row, $event)"></app-button-edit>
                    </ng-template>
                </app-exper-column>
            </ng-container>
        </app-exper-table>
    </div>
</ng-container>
